// 11 Sep 1906
import { createSlice } from '@reduxjs/toolkit'
import { REDUX_STATUS_IDLE } from 'src/consumer/constants'

const initialState = {
  vitalsFormSettings: {
    state: REDUX_STATUS_IDLE,
    data: [],
    error: null,
  },
}

const vitalsFormSettingsSlice = createSlice({
  name: 'vitalsFormSettingsStore',
  initialState: initialState,
  reducers: {
    setVitalsFormSettingsData(state, action) {
      return {
        ...state,
        vitalsFormSettings: {
          ...(state?.vitalsFormSettings || {}),
          data: action.payload,
        },
      }
    },
    setVitalsFormSettingsError(state, action) {
      return {
        ...state,
        vitalsFormSettings: {
          ...(state?.vitalsFormSettings || {}),
          error: action.payload,
        },
      }
    },
    setVitalsFormSettingsState(state, action) {
      return {
        ...state,
        vitalsFormSettings: {
          ...(state?.vitalsFormSettings || {}),
          state: action.payload,
        },
      }
    },
  },
})

function selectVitalsFormSettingsStore(state) {
  return state.vitalsFormSettingsStore
}

export const {
  setVitalsFormSettingsData,
  setVitalsFormSettingsError,
  setVitalsFormSettingsState,
} = vitalsFormSettingsSlice.actions

export const vitalsFormSettingsReducer = vitalsFormSettingsSlice.reducer

export const selectVitalsFormSettingsData = (state) => selectVitalsFormSettingsStore(state).vitalsFormSettings